import { getCache, setCache, clearAllCache } from '@/services/cacheService.js'

export async function fetchDataWithCache(apiKey, fetchFunction, lastUpdated, processingUUID) {
  const cachedData = await getCache(apiKey)

  if (cachedData) {
    if (lastUpdated === cachedData.lastUpdated && processingUUID === cachedData.processingUUID) {
      return cachedData.data
    } else {
      if ([lastUpdated, cachedData.lastUpdated, processingUUID, cachedData.processingUUID].every(Boolean)) {
        await clearAllCache(apiKey)
      }
    }
  }

  const result = await fetchFunction()

  await setCache(apiKey, result, lastUpdated, processingUUID)

  return result
}
